import { create } from 'zustand'

import {
  type IUseBookingState,
  type IUseBookingStatus,
} from '../interfaces/state'

export const useBookingState = create<IUseBookingState>((set) => ({
  send_email_confirmation: false,
  resend_flecto_link_confirmation_visible: false,
  updateEmailConfirmation: (send_email_confirmation) => {
    set(() => ({ send_email_confirmation }))
  },
  toggleResendFlectoLink: (resend_flecto_link_confirmation_visible) => {
    set(() => ({ resend_flecto_link_confirmation_visible }))
  },
}))

export const useBookingStatus = create<IUseBookingStatus>((set) => ({
  tableItemsLoading: false,
  registerPaymentStep: 'payment',
  update: (newState) => {
    set(() => ({ ...newState }))
  },
  setRegisterPaymentStep: (registerPaymentStep) => {
    set(() => ({ registerPaymentStep }))
  },
}))

export default useBookingState
